import { render, staticRenderFns } from "./BatchUpdateMainGroupbuy.vue?vue&type=template&id=6fb29d34&scoped=true&"
import script from "./BatchUpdateMainGroupbuy.vue?vue&type=script&lang=js&"
export * from "./BatchUpdateMainGroupbuy.vue?vue&type=script&lang=js&"
import style0 from "./BatchUpdateMainGroupbuy.vue?vue&type=style&index=0&id=6fb29d34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb29d34",
  null
  
)

export default component.exports